"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Measure = /** @class */ (function () {
    function Measure(value, unit) {
        this._value = value;
        this._unit = unit;
    }
    Object.defineProperty(Measure.prototype, "Value", {
        get: function () {
            return this._value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Measure.prototype, "Unit", {
        get: function () {
            return this._unit;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Measure.prototype, "AbbreviatedDisplay", {
        get: function () {
            return this.Value.toFixed(2) + " " + this.Unit.AbbreviatedDisplay;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Measure.prototype, "FullDisplay", {
        get: function () {
            return this.Value.toFixed(2) + " " + this.Unit.FullDisplay;
        },
        enumerable: true,
        configurable: true
    });
    Measure.prototype.ToLongDisplay = function () {
        return this.Value.toFixed(4) + " " + this.Unit.FullDisplay;
    };
    Measure.prototype.GetValueAs = function (targetUnit) {
        var m = this.CreateAs(targetUnit);
        return m.Value;
    };
    Measure.prototype.Negate = function () {
        return this.Unit.GetMeasure(this.Value * -1);
    };
    Measure.prototype.toJSON = function () {
        return {
            AbbreviatedDisplay: this.AbbreviatedDisplay,
            FullDisplay: this.FullDisplay,
            Unit: this.Unit.toJSON(),
            Value: this.Value
        };
    };
    return Measure;
}());
exports.Measure = Measure;
